import EmblaCarousel from 'embla-carousel'
import AutoScroll from 'embla-carousel-auto-scroll'

$(document).ready(function() {
    $('.embla').each(function() {
      const emblaNode = this; 
      const options = { loop: true };

      const emblaApi = EmblaCarousel(emblaNode, options, [AutoScroll({ playOnInit: true })]);
      emblaApi.slideNodes();
  });
});
